(() => {
  const TARGETS = [
    ['__ace_membership_intro', 262, '会員割引の内容を見る'],
    ['main [id$="__ace_preference_finder"] .ace-preferences__panel', 340, 'キーワードをもっと見る'],
    ['__collection-list', 800, 'すべてのカテゴリーを見る'],
    ['__ace_space_gallery', 600, '事例をもっと見る']
  ];
  const folded = [];
  const bgOf = (node) => {
    let el = node;
    while (el && el !== document.documentElement) {
      const c = getComputedStyle(el).backgroundColor;
      if (c && c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent') return c;
      el = el.parentElement;
    }
    return '#fff';
  };
  const setOpen = (item, open, scroll) => {
    item.sec.classList.toggle('is-open', open);
    item.btn.setAttribute('aria-expanded', String(open));
    item.btn.textContent = open ? '閉じる ▲' : item.label + ' ▼';
    if (!open && scroll) item.sec.scrollIntoView({ block: 'start' });
  };
  const run = () => {
    TARGETS.forEach(([suffix, height, label]) => {
      const sec = document.querySelector(suffix.indexOf('main') === 0 ? suffix : 'main [id$="' + suffix + '"]');
      if (!sec || sec.scrollHeight <= height + 140) return;
      sec.classList.add('ace-fold');
      sec.style.setProperty('--ace-fold-h', height + 'px');
      if (suffix === '__collection-list') {
        const fit = () => {
          const g = sec.querySelector('.ace-odp-browser__group');
          if (!g) return;
          const h = Math.round(g.getBoundingClientRect().bottom - sec.getBoundingClientRect().top + 22);
          if (h > 300) sec.style.setProperty('--ace-fold-h', h + 'px');
        };
        fit();
        setTimeout(fit, 800);
        setTimeout(fit, 2500);
        window.addEventListener('resize', fit);
      }
      sec.style.setProperty('--ace-fold-bg', bgOf(sec.firstElementChild || sec));
      const bar = document.createElement('div');
      bar.className = 'ace-fold__bar';
      bar.style.background = bgOf(sec.firstElementChild || sec);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ace-fold__toggle';
      bar.appendChild(btn);
      sec.after(bar);
      const item = { sec, btn, label };
      folded.push(item);
      setOpen(item, false, false);
      btn.addEventListener('click', () => setOpen(item, !sec.classList.contains('is-open'), true));
      sec.addEventListener('click', () => { if (!sec.classList.contains('is-open')) setOpen(item, true, false); });
      sec.addEventListener('focusin', () => { if (!sec.classList.contains('is-open')) setOpen(item, true, false); });
    });
    openForHash();
  };
  const openForHash = () => {
    let target = null;
    try { target = location.hash.length > 1 ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null; } catch (error) { target = null; }
    if (!target) return;
    folded.forEach((item) => { if (item.sec.contains(target) && target !== item.sec) { setOpen(item, true, false); target.scrollIntoView({ block: 'start' }); } });
  };
  window.addEventListener('hashchange', openForHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
